// extracted by mini-css-extract-plugin
export default {"link":"MenuLink_link__FK5fK","disabled":"MenuLink_disabled__h9zqj","active":"MenuLink_active__LbnCl","additional":"MenuLink_additional__5IaYp"};